import pspdfkitLicenseKeys from "src/pspdfkit-license-keys.json"

const dynamicEnvHostnameRegex = /^patients-us\.myveevalocal.*\.com$/
const dynamicEnvBundleId = "patients-us.myveevalocal*.com"

export const envs = [
  {
    shorthand: "ft",
    urls: [
      "https://patients-us-ft.myveeva.com",
      "https://patients-eu-ft.myveeva.com",
    ],
  },
  {
    shorthand: "pr",
    urls: ["https://patients-us-pr.myveeva.com"],
  },
  {
    shorthand: "prod",
    urls: [
      "https://patients-us.myveeva.com",
      "https://patients-eu.myveeva.com",
      "https://patients-ap.myveeva.com",
    ],
  },
  {
    shorthand: "sbx",
    urls: [
      "https://patients-us-sbx.myveeva.com",
      "https://patients-eu-sbx.myveeva.com",
      "https://patients-ap-sbx.myveeva.com",
    ],
  },
  {
    shorthand: "val",
    urls: ["https://patients-us-validation.myveeva.com"],
  },
  {
    shorthand: "valsbx",
    urls: ["https://patients-us-validation-sbx.myveeva.com"],
  },
  {
    shorthand: "dev",
    urls: [
      "https://patients-us-dev.myveevatrials.com",
      "https://patients-us-dev-ft.myveevatrials.com",
      "https://patients-ap-dev-ft.myveevatrials.com",
    ],
  },
  {
    shorthand: "devftsbx",
    urls: [
      "https://patients-us-dev-ft-sbx.myveevatrials.com",
      "https://patients-ap-dev-ft-sbx.myveevatrials.com",
    ],
  },
  {
    shorthand: "devst",
    urls: ["https://patients-us-dev-st.myveevatrials.com"],
  },
  {
    shorthand: "devval",
    urls: ["https://patients-us-validation.myveevatrials.com"],
  },
  {
    shorthand: "local",
    urls: ["https://patients-us.local.com:3000"],
  },
  {
    shorthand: "perfst",
    urls: [
      "https://patients-us-perfst.myveevatrials.com",
      "https://patients-ap-perfst.myveevatrials.com",
    ],
  },
  {
    shorthand: "perfstsbx",
    urls: [
      "https://patients-us-perfst-sbx.myveevatrials.com",
      "https://patients-ap-perfst-sbx.myveevatrials.com",
    ],
  },
  {
    shorthand: "qaft1",
    urls: ["https://patients-us-qa-ft1.myveevatrials.com"],
  },
  {
    shorthand: "qaft2",
    urls: [
      "https://patients-us-qa-ft2.myveevatrials.com",
      "https://patients-ap-qa-ft2.myveevatrials.com",
    ],
  },
  {
    shorthand: "qaft2sbx",
    urls: [
      "https://patients-us-qa-ft2-sbx.myveevatrials.com",
      "https://patients-ap-qa-ft2-sbx.myveevatrials.com",
    ],
  },
  {
    shorthand: "qast1",
    urls: [
      "https://patients-us-qa-st1.myveevatrials.com",
      "https://patients-ap-qa-st1.myveevatrials.com",
    ],
  },
  {
    shorthand: "qast1sbx",
    urls: [
      "https://patients-us-qa-st1-sbx.myveevatrials.com",
      "https://patients-ap-qa-st1-sbx.myveevatrials.com",
    ],
  },
  {
    shorthand: "qast2",
    urls: [
      "https://patients-us-qa-st2.myveevatrials.com",
      "https://patients-ap-qa-st2.myveevatrials.com",
    ],
  },
  {
    shorthand: "qast2sbx",
    urls: [
      "https://patients-us-qa-st2-sbx.myveevatrials.com",
      "https://patients-ap-qa-st2.myveevatrials.com",
    ],
  },
  {
    shorthand: "scratch1",
    urls: ["https://patients-us-sample.myveevatrials.com"],
  },
  {
    shorthand: "scratch2",
    urls: [
      "https://patients-us-sample2.myveevatrials.com",
      "https://patients-ap-sample2.myveevatrials.com",
    ],
  },
  {
    shorthand: "scratch2sbx",
    urls: ["https://patients-us-sample2-sbx.myveevatrials.com"],
  },
]

export const getPspdfkitLicense = (): string | undefined => {
  let license = process.env.REACT_APP_PSPDFKIT_LICENSE_KEY
  if (license) {
    return license
  }

  const hostname = window.location.hostname
  const bundleId = dynamicEnvHostnameRegex.test(hostname)
    ? dynamicEnvBundleId
    : hostname

  // lookup bundleId in the pspdfkit-license-keys.json file
  license = pspdfkitLicenseKeys.find(
    (bundle) => bundle.bundle_id === bundleId
  )?.license_key
  if (!license) {
    if (process.env.REACT_APP_mock_services === "true") {
      // this case handles mocks built for pm reviews
      return undefined
    }
    throw new Error("Missing pspdfkit license for current hostname.")
  }
  return license
}
